import styled from "styled-components";

export const ServicesContainer = styled.section`
  margin: 0 auto;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background: ${({ lightBg }) => (lightBg ? "#f9f9f9" : "#010606")};
  height: 100vh;
  @media all and (max-width: 768px) {
    height: 100%;
  } ;
`;

export const ServicesHeading = styled.h3`
  color: #010606;
  text-align: center;
  padding: 2rem 0.5rem 2rem 0.5rem;
  margin-bottom: 24px;
  font-size: 48px;
  line-height: 1.1;
  font-weight: 600;

  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const ServicesP = styled.p`
  font-size: 0.9rem;
  margin: 1rem 0;
  line-height: 1.5;
`;

export const ServicesWrapper = styled.div`
  max-width: 1000px;
  margin: auto;
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  --webkit-box-align: center;
  align-items: center;
  @media all and (max-width: 768px) {
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-flow: row wrap;
  } ;
`;

export const ServicesCard = styled.div`
  background: #fff;
  margin: 20px;
  padding: 20px;
  border-radius: 4px;
  text-align: center;
  --webkit-box-flex: 1;
  flex: 1;
  flex: 1 0 21%; /* explanation below */
  margin: 5px;
  flex-direction: column;
  align-items: center;
  display: flex;
  border: 2px solid #e7e7e7;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
  justify-content: center;
  @media all and (max-width: 738px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  } ;
`;

export const ServicesImg = styled.div`
  border-radius: 50%;
  box-shadow: 0 0 0 3px #e7e7e7;
  width: 100px;
  height: 100px;
  @media all and (max-width: 1024px) {
    width: 120px;
    height: 120px;
  } ;
`;

export const Img = styled.img`
  height: 100%;
  width: 100%;
  padding: 15px 15px;
`;

export const ServicesH4 = styled.h4`
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  color: #000;
  font-size: 1.3rem;
  margin: 1rem 0 0.6rem;
`;
